/* eslint-disable import/prefer-default-export */

export function reportWorkerError(errorEvent, source) {
  const message = errorEvent.message || `${errorEvent.filename || 'worker'}:${errorEvent.lineno || 0}`;
  const filename = errorEvent.filename || 'worker';
  const lineno = errorEvent.lineno || 0;
  const colno = errorEvent.colno != null ? errorEvent.colno : 0;

  const err = new Error(message);
  err.stack = `Error: ${message}\n    at onmessage (${filename}:${lineno}:${colno})`;

  err._meta = { worker: { source, filename, lineno, colno } };
  err._errorName = 'WORKER_ERROR';

  throw err;
}
